<template>
    <div>
        <!-- 吸顶导航 -->
        <van-sticky>
            <van-nav-bar style="background-color: #3f78f6; margin-bottom: 0rem;border:0" title="" left-text=""
                left-arrow @click-left="onClickLeft">
                <template #title>
                    <span style="color: white;font-size: .4rem;">请假申请</span>
                </template>
                <template #left>
                    <van-icon name="arrow-left" color="white" size="18" />
                </template>
            </van-nav-bar>
        </van-sticky>
        <van-form class="van-form" style="margin-top:20px" @submit="onSubmit">
            <van-field v-model="fname" label="教师姓名" name="fname" placeholder="请输教师姓名"
                :rules="[{ required: true, message: '请输教师姓名' }]" />
            <van-field v-model="scode" label="学生学号" name="scode" placeholder="请输入学生学号"
                :rules="[{ required: true, message: '请输入学生学号' }]" style="margin-top:20px" />
            <van-field v-model="sname" label="学生姓名" name="sname" placeholder="请输入学生姓名"
                :rules="[{ required: true, message: '请输入学生姓名' }]" style="margin-top:20px" />

            <!--开始时间选择 -->
            <van-field readonly clickable name="datetimesPicker" :value="qjtime+''" label="开始时间" placeholder="点击选择时间"
                @click="showpickerstime = true" style="margin-top:20px" />
            <van-popup v-model="showpickerstime" position="bottom">
                <van-datetime-picker v-model="currentDate" type="datetime" @confirm="onConfirms"
                    @cancel="showpickerstime = false" />
            </van-popup>
            <!--结束时间选择 -->
            <van-field readonly clickable name="datetimeePicker" :value="qjetime+''" label="结束时间" placeholder="点击选择时间"
                @click="showpickeretime = true" style="margin-top:20px" />
            <van-popup v-model="showpickeretime" position="bottom">
                <van-datetime-picker v-model="currentDate" type="datetime" @confirm="onConfirme"
                    @cancel="showpickeretime = false" />
            </van-popup>
            <!--其它标签 -->
            <van-field readonly clickable name="typename" :value="typename" label="请假类型" placeholder="请选择请假类型"
                @click="showPicker = true" style="margin-top:20px" />
            <van-popup v-model="showPicker" position="bottom">
                <van-picker show-toolbar :columns="columns" value-key="tname" @confirm="onConfirm1"
                    @cancel="showPicker = false" />
            </van-popup>
            <van-field v-model="qjcontent" label="请假事由" name="qjcontent" placeholder="请输请假事由"
                :rules="[{ required: true, message: '请输入请假事由' }]" style="margin-top:20px" />
            <van-field readonly clickable name="lixiao" :value="lixiao" label="是否离校" placeholder="是否离校"
                @click="showlixiao = true" style="margin-top:20px" />
            <van-popup v-model="showlixiao" position="bottom">
                <van-picker show-toolbar :columns="columnsl" value-key="tli" @confirm="onConfirm2"
                    @cancel="showlixiao = false" />
            </van-popup>
            <div style="margin: 16px;margin-top:40px">
                <van-button round block type="info" native-type="submit">
                    提交
                </van-button>
            </div>
        </van-form>
    </div>
</template>
<script>
    import format from '@/format.js'

    export default {
        data() {
            return {
                currentDate: new Date(),
                qjtime: '',
                code: "",
                qjetime: '',
                typename: '',
                lixiao: "",
                typeid: "",
                typedata: [],
                showCalendar: false,
                fname: "",
                scode: "",
                sname: "",
                qjcontent: "",
                columns: [],
                columnsl: ["是", "否"],
                showPicker: false,
                showlixiao: false,
                showpickerstime: false,
                showpickeretime: false,
            };
        },
        created() {
            var json = window.localStorage.getItem("User");
            var jsonObj = JSON.parse(json);
            this.fname = jsonObj[0]["username"];
            console.log("身份:" + jsonObj[0]["shenfen"]);
            var code;
            if (jsonObj[0]["shenfen"] == "老师") {
                code = jsonObj[0]["number"];
            } else if (jsonObj[0]["shenfen"] == "学生") {
                code = jsonObj[0]["number"];
            } else {
                code = jsonObj[0]["phone"];
            }
            this.code = code;
            var params_json = {
                userid: code,
                action: "QJTypeList",
                param1: "",
                param2: "",
                param3: "",
                param4: "",
                param5: ""
            };

            this.$http
                .post("/web/list", params_json)
                .then(function (res) {
                    // let obj = res.data["rows"];
                    console.log(res.data["rows"]);
                    this.typedata = res.data["rows"];
                    // this.columns[0].value.push(this.typedata);
                    for (var i in this.typedata) {
                        var obj = {
                            tname: res.data["rows"][i]["fname"],
                            id: res.data["rows"][i]["id"]
                        }
                        this.columns.push(obj);
                    }
                });
        },
        methods: {
            onSubmit(values) {
                console.log("submit", values);
                var params_json = {
                    userid: this.code,
                    action: "QJSubmit",
                    param1: values.scode + "#" + values.sname,
                    param2: values.fname,
                    param3: this.typeid + "#" + values.typename,
                    param4: values.datetimesPicker + "#" + values.datetimeePicker,
                    param5: this.lixiao + "#" + values.qjcontent
                };
                this.$http
                    .post("/web/save", params_json)
                    .then(function (res) {
                        let obj = res.data;
                        console.log("注册后返回消息:" + obj.msg);
                        if (obj.msg == "0") {
                            this.$notify({
                                type: "success",
                                message: "操作成功。"
                            });
                            setTimeout(() => {
                                this.$router.push("StudentLeave");
                            }, 3000);
                        } else {
                            this.$notify({
                                type: "warning",
                                message: obj.msg
                            });
                        }
                    });
            },
            onClickLeft() {
                this.$router.push("StudentLeave");
            },
            onClickRight() {
                // 危险通知
                this.$toast("失败文案");
            },
            onConfirm1(value) {
                console.log(value.tname);
                this.typename = value.tname;
                this.typeid = value.id;
                this.showPicker = false;
            },
            onConfirm2(value) {
                console.log(value);
                this.lixiao = value;
                this.showlixiao = false;
            },
            onConfirms(time) {
                this.qjtime = format(time, "YYYY-MM-DD HH:mm:ss");
                this.showpickerstime = false;
            },
            onConfirme(time) {
                this.qjetime = format(time, "YYYY-MM-DD HH:mm:ss");
                this.showpickeretime = false;
            },
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    .van-doc-demo-block__title {
        margin: 0;
        padding: 32px 16px 16px;
        color: rgba(69, 90, 100, 0.6);
        font-weight: normal;
        font-size: 16px;
        line-height: 16px;
        font-weight: bold;
    }

    .van-doc-demo-block__card {
        margin: 12px 12px 0;
        overflow: hidden;
        border-radius: 8px;
    }

    .van-doc-demo-block__title+.van-doc-demo-block__card {
        margin-top: 0;
    }

    .van-doc-demo-block:first-of-type .van-doc-demo-block__title {
        padding-top: 20px;
    }
</style>
<style>
    .demo-col {
        background: #fff;
    }

    .demo-col .van-doc-demo-block {
        padding: 0 16px;
    }

    .demo-col .van-doc-demo-block__title {
        padding-left: 0;
    }

    .demo-col .van-col {
        margin-bottom: 10px;
        color: #fff;
        font-size: 13px;
        line-height: 30px;
        text-align: center;
        background-clip: content-box;
    }

    .demo-col .van-col:nth-child(odd) {
        background-color: #39a9ed;
    }

    .demo-col .van-col:nth-child(even) {
        background-color: #66c6f2;
    }
</style>